/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my JSON sent to a server?`)
};

const es_jf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se envía mi JSON a un servidor?`)
};

const de_jf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird mein JSON an einen Server gesendet?`)
};

const nl_jf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt mijn JSON naar een server verzonden?`)
};

const fr_jf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon JSON est-il envoyé à un serveur ?`)
};

const it_jf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il mio JSON viene inviato a un server?`)
};

const pt_br2_jf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu JSON é enviado para um servidor?`)
};

const pt_jf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O meu JSON é enviado para um servidor?`)
};

const ja_jf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONはサーバーに送信されますか？`)
};

const zh_jf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的 JSON 会被发送到服务器吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_faq1_q", locale)
	if (locale === "en") return en_jf_faq1_q(inputs)
	if (locale === "es") return es_jf_faq1_q(inputs)
	if (locale === "de") return de_jf_faq1_q(inputs)
	if (locale === "nl") return nl_jf_faq1_q(inputs)
	if (locale === "fr") return fr_jf_faq1_q(inputs)
	if (locale === "it") return it_jf_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_jf_faq1_q(inputs)
	if (locale === "pt") return pt_jf_faq1_q(inputs)
	if (locale === "ja") return ja_jf_faq1_q(inputs)
	return zh_jf_faq1_q(inputs)
};